import { Component, OnInit } from '@angular/core';
import { LocalizacionesService } from '../../_services/localizaciones.service';
import { Localizaciones } from '../../_models/localizaciones';
import { DivisionPoliticaService } from '../../_services/division-politica.service';
import { DivisionPolitica } from '../../_models/division-politica';
import { AliadoSucursal } from '../../_models/aliado-sucursal';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { TerceroService } from '../../_services/tercero.service';
import { AliadoSucursalService } from '../../_services/aliado-sucursal.service';
import { Tercero } from '../../_models/tercero';
import { Location } from '@angular/common';
import { Aliado } from '../../_models/aliado';
import { AliadoService } from '../../_services/aliado.service';

@Component( {
  selector: 'app-aliados-sucursales-detalle',
  templateUrl: 'aliados-sucursales-detalle.component.html'
} )

export class AliadosSucursalesDetalleComponent implements OnInit {

  sucursal: AliadoSucursal;
  localizacion: Localizaciones = new Localizaciones();
  municipio: DivisionPolitica = new DivisionPolitica();
  carInformacionInicial = true;
  aliado: Aliado;
  tercero: Tercero;
  todo: boolean;

  constructor( private terServicio: TerceroService,
               private sucServicio: AliadoSucursalService,
               private location: Location,
               private aliServicio: AliadoService,
               private route: ActivatedRoute ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      this.todo = this.route.snapshot.data[ 'todo' ] ? true : false;
      forkJoin(
        this.aliServicio.obtenerPorId( params[ 'id' ] ),
        this.sucServicio.obtenerPorIdConCampos( params[ 'idSucursal' ] )
      ).subscribe( ( [ aliado, sucursal ] ) => {
        this.aliado = aliado;
        this.terServicio.get( this.aliado.idTercero ).subscribe( ter => {
          this.tercero = ter;
          this.sucursal = sucursal;
          this.carInformacionInicial = false;
        } );
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
